import React from 'react';
import styles from './FormField.module.scss';

interface ToggleGroupProps {
  options: { value: string; label: string }[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
  style?: React.CSSProperties;
}

export function ToggleGroup({ options, value, onChange, className, style }: ToggleGroupProps) {
  return (
    <div className={`${styles.toggleGroup} ${className || ''}`} style={style}>
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          className={`${styles.toggleGroupBtn} ${value === opt.value ? styles.toggleGroupActive : ''}`}
          onClick={() => onChange(opt.value)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
